import api from '@/apis/BaseApi';
import { QuizTemplateModel } from '@/apis/models/QuizModel';

export default class QuizTemplateApi {
  static async list(): Promise<QuizTemplateModel[]> {
    const result = await api.get('quiz-templates/');
    return result.data;
  }
}
